import React from 'react';
import {Spin} from "antd";

const LoaderComponents = (props) => {
    return props.isLoading && <Spin
        className={"w-full h-full grid place-items-center absolute top-0 left-0 backdrop-blur-md bg-white/50 z-10"}/>
}
export default LoaderComponents
